export const CITIES = [
  'ARAUCA',
  'ARAUQUITA',
  'RONDÓN',
  'SARAVENA',
  'PUEBLO NUEVO'
];

export const PERSON_TYPE_OPTIONS = [
  { text: 'Persona', value: 'Person' },
  { text: 'Empresa', value: 'Company' }
];

export const FISCAL_RESPONSIBILITIES = [
  { text: 'R-99-PN No aplica - Otros', value: 'R-99-PN' }
  // { text: '0-13 Gran contribuyente', value: '0-13' },
  // { text: 'O-15 Autorretenedor', value: '0-15' },
  // { text: 'O-23 Agente de retención IVA', value: '0-23' },
  // { text: 'O-47 Régimen simple de tributación', value: '0-47' }
];

export const ID_TYPE_OPTIONS = [
  { text: 'Registro civil', value: '11' },
  { text: 'Tarjeta de identidad', value: '12' },
  { text: 'Cédula de ciudadanía', value: '13' },
  { text: 'Tarjeta de extranjería', value: '21' },
  { text: 'Cédula de extranjería', value: '22' },
  { text: 'NIT', value: '31' },
  { text: 'Pasaporte', value: '41' },
  { text: 'Documento de identificación extranjero', value: '42' },
  { text: 'NUIP', value: '91' },
  { text: 'Permiso especial de permanencia PEP', value: '47' },
  {
    text: 'Sin identificación del exterior o para uso definido por la DIAN',
    value: '43'
  },
  {
    text: 'Nit de otro país / Sin identificación del exterior (43 medios magnéticos)',
    value: '50'
  },
  { text: 'Salvoconducto de permanencia', value: '89' },
  { text: 'Permiso protección temporal PPT', value: '48' }
];
